import { Link } from "react-router-dom";
import "../styles/Notfound.css";

function EmailConfirmed() {
  return (
    <div className="Notfound">
      <div className="Middle">
        <h2>Email verified!</h2>
        <p>You've successfully confirmed your email.</p>
        <Link to="/">Continue to Ski studio</Link>
      </div>
    </div>
  );
}

export default EmailConfirmed;
